export const MODE = {
    IMAGE: "image",
    TEXT: "text",
    GENERAL: "general",
    FUNCTION: "function",
    NONE: "none"
}